import { IBaseUserRight } from '@zz2/zz2-ui';
import { IUser } from '../../@types/model/auth/user/user';
import { RIGHT_GRANTS } from '../../appConstants';
import { getUserSelectedDepartmentsLocalStorage, getUserSelectedDivisionsLocalStorage } from '../localStorageService';
import { IDepartment } from '../../@types/model/masterData/department/department';

export default class UserHelper {

    public static getUserDivisionHeading = (user : IUser) : string => {
        const userDivisionIds = user.userDivisions.filter(x => x.isActive && x.division?.isActive).map(x => x.divisionId);
        if (userDivisionIds.length < 1) return 'NO DIVISION SELECTED';
        const selectedDivisions = getUserSelectedDivisionsLocalStorage();
        
        const selectedDivisionCount = selectedDivisions.length;
     
        switch (selectedDivisionCount) {
            case 0:
                return 'NO DIVISION SELECTED';
            case 1:
                return selectedDivisions[0].label;
            case userDivisionIds.length:
                return 'ALL DIVISIONS';
            default:
                return 'MULTIPLE DIVISIONS';
        }
    };

    public static getUserDepartmentHeading = (user : IUser) : string => {
        if (!user.departmentIds) return 'NO DEPARTMENT SELECTED';
        const selectedDivisions = getUserSelectedDivisionsLocalStorage();
        const selectedDepartments = getUserSelectedDepartmentsLocalStorage();

        const activeUserDepartments = user.userDepartments
            .filter(userDept => userDept.isActive && userDept.department && userDept.department.isActive)
            .map(userDept => userDept.department as IDepartment);

        const filteredDepartments = activeUserDepartments
            .filter(dept => selectedDivisions.map(div => div.value).includes(dept.subdivision?.divisionId ?? 0));

        const selectedDepartmentCount = selectedDepartments.length;
    
        switch (selectedDepartmentCount) {
            case 0:
                return 'NO DEPARTMENT SELECTED';
            case 1:
                return selectedDepartments[0].label;
            case filteredDepartments.length:
                return 'ALL DEPARTMENTS';
            default:
                return 'MULTIPLE DEPARTMENTS';
        }
    };

    public static userSpecificRightGrantLevels = (rightCode : string, userRights ?: Array<IBaseUserRight>) => {
        const userHasRights = userRights?.filter(x => x.isActive && x.right.code === rightCode) ?? [];

        return {
            viewRight: userHasRights.some(x => x.rightGrantLevel === RIGHT_GRANTS.View),
            addRight: userHasRights.some(x => x.rightGrantLevel === RIGHT_GRANTS.Add),
            editRight: userHasRights.some(x => x.rightGrantLevel === RIGHT_GRANTS.Edit),
            deleteRight: userHasRights.some(x => x.rightGrantLevel === RIGHT_GRANTS.Delete),
            adminRight: userHasRights.some(x => x.rightGrantLevel === RIGHT_GRANTS.Admin)
        };
    }

    public static userRelatedRights = (pathname : string, userRights ?: Array<IBaseUserRight>) => {
        const userHasRights = userRights?.filter(x => x.isActive && x.right.url !== null && x.right.url.toLowerCase() === pathname.toLowerCase()) ?? [];

        return {
            viewRight: userHasRights.some(x => x.rightGrantLevel === RIGHT_GRANTS.View),
            addRight: userHasRights.some(x => x.rightGrantLevel === RIGHT_GRANTS.Add),
            editRight: userHasRights.some(x => x.rightGrantLevel === RIGHT_GRANTS.Edit),
            deleteRight: userHasRights.some(x => x.rightGrantLevel === RIGHT_GRANTS.Delete),
            adminRight: userHasRights.some(x => x.rightGrantLevel === RIGHT_GRANTS.Admin)
        };
    }

    public static getRelatedRightToolTipMessage = (dataType : string, level : RIGHT_GRANTS) : string => {
        let rightLevel = '';
        switch (level) {
            case (RIGHT_GRANTS.Add):
                rightLevel = 'Add';
                break;

            case (RIGHT_GRANTS.Edit):
                rightLevel = 'Edit';
                break;

            case (RIGHT_GRANTS.Delete):
                rightLevel = 'Delete';
                break;

            case (RIGHT_GRANTS.Admin):
                rightLevel = 'Admin';
                break;

            default:
                break;
        }

        return `Right: ${dataType} with Level: ${rightLevel} is required to perform this action. \n\nClick to request permission.`;
    }
}